import React, { useCallback } from "react";
import { useParams, useLoaderData, Await } from "react-router-dom";
import { getKeyForHold, HoldsSharedView } from "./HoldsSharedView";
import { cancelHold, unsuspendHold } from "../../../services/Holds";
import { childHoldsLoader } from "./childHoldsLoader";
import { LSResultItemListWithToolbarSkeleton } from "../../search/ls/LSResultItem/LSResultItemListWithToolbarSkeleton";
import { useAccount } from "@tlc/ls2pac/components/Account";
import { HostSystemItemView } from "@tlc/ls2pac/dto/HostSystemItemView";
import { HoldsSelectionProvider } from "./HoldsSelectionContext";

export const ChildHoldsView: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { patron } = useAccount();
  const childId = parseInt(id!);
  const child = (patron?.children || []).find((c) => c.id === childId);

  const { data, pageSize } = useLoaderData() as {
    data: Promise<typeof childHoldsLoader>;
    pageSize: number;
  };

  const getId = useCallback(
    (item: HostSystemItemView) => getKeyForHold(item),
    [],
  );

  return (
    <React.Suspense
      fallback={
        <LSResultItemListWithToolbarSkeleton
          pageSize={pageSize}
          hideCheckbox={true}
          hideActions={true}
        />
      }
    >
      <Await resolve={data}>
        {({
          sort,
          page,
          pageSize,
          holds,
          childHoldsTotalCount,
          childHoldsTotalArrived,
        }) => {
          return (
            <HoldsSelectionProvider items={holds} getId={getId}>
              <HoldsSharedView
                page={page}
                pageSize={pageSize}
                sort={sort}
                isStudent={true}
                holds={holds}
                patronId={child?.barcode || ""}
                digitalInformationLastUpdated={undefined}
                cancelHoldsApi={cancelHold}
                unsuspendHoldsApi={unsuspendHold}
                totalHolds={childHoldsTotalCount}
                totalArrivedHolds={childHoldsTotalArrived}
              />
            </HoldsSelectionProvider>
          );
        }}
      </Await>
    </React.Suspense>
  );
};
